import { render, staticRenderFns } from "./MemberTypeUpdateForm.vue?vue&type=template&id=52429cbc&"
import script from "./MemberTypeUpdateForm.vue?vue&type=script&lang=js&"
export * from "./MemberTypeUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports